module.exports = __webpack_public_path__ + "media/images/sms-af98f8cb3398a026e6c46715e70df281.svg";